export const STRINGS = {
  INITIAL_SYNC_FAILED: 'Initial sync failed',
};
